// 俄语
import constant from '../../constants/lang/ru-RU';
import newLang from '../newLang/ru';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Пожалуйста, сначала войдите',
        404: 'Нет данных',
        500: 'Система занята, повторите попытку позже',
        504: 'Истекло время запроса',
        ERR_NETWORK: 'Исключение сети',
        ERR_NETWORK_UPLOAD: 'Загрузка не удалась, попробуйте другую сеть',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'световой индикатор',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Рекорды',
        'feedback-create': 'Обратная связь',
        'feedback-supplement': 'Дополнительная обратная связь',
        'feedback-detail': 'Детали обратной связи',
        'feedback-result': 'Обратная связь',
        guide: 'Центр помощи',
        'guide-restScreen': 'Инструкции по установке',
        'guide-overview': 'Обзор функций',
        'guide-account': 'О счете',
        'guide-vehicle': 'О транспортном средстве',
        'guide-meterSetting': 'Как настроить приборную панель',
        'guide-vehicleSetting': 'Как настроить автомобиль',
        'guide-findNavigation': 'Как найти автомобиль с помощью навигации',
        'guide-vehicleNnavigation': 'Как пользоваться навигацией',
        'guide-cyclingRecord': 'Об истории поездок',
        'guide-vehicleExperience': 'Как провести самопроверку автомобиля',
        'guide-useSetting': 'Как сделать общие настройки приложения',
        'guide-notice': 'Как просмотреть и настроить уведомление о сообщении',
        'guide-about': 'О приложении',
        help: 'Помощь & обратная связь',
        'help-detail': 'Детали вопроса',
        'myCar-unbinding': 'Применить отвязать',
        'myCar-unbinding-result': 'Применить отвязать',
      },
    },
    form: {
      cancel: 'Отменить',
      confirm: 'Подтверждаю',
      submit: 'Отправить',
      search: 'Поиск',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Протокол`,
      text1: '1.	Телематические услуги',
      text2:
        'CFMOTO Powersports, Inc. (далее именуемая « CFMOTO » ) предоставляет услуги автомобильной телематики клиенту, купившему автомобиль CFMOTO (далее именуемому «Клиент» ). Для этих услуг CFMOTO использует данные, записанные Транспортным средством о транспортном средстве и его поведении за соответствующий период времени. Подробно это касается следующих данных:',
      text3: 'Данные о поведении пользователя за рулем : включая ускорение, замедление, скорость, изгиб, время последнего вождения и последний пробег вождения .',
      text4:
        'Данные о состоянии транспортного средства: относятся к состоянию транспортного средства в реальном времени, включая режим вождения, остаточное топливо, мгновенную экономию топлива, пробег, передачу транспортного средства в реальном времени, частоту вращения двигателя, давление в шинах, температуру шин, данные о напряжении аккумулятора. , температура охлаждающей жидкости, состояние электронного замка, версия программного обеспечения интеллектуального устройства, мощность сигнала интеллектуальных устройств, текущая настройка приборной панели.',
      text5:
        'Данные тревоги автомобиля: данные тревоги, которые будут отправлены, если определенные данные превышают заданное значение, например, температура двигателя, превышение скорости, чрезмерное время вождения, высокая температура охлаждающей жидкости, ненормальное движение автомобиля, ненормальное давление в шинах, вибрация, сброс, столкновение и т . д . .',
      text6: 'Информация о неисправности автомобиля: относится к кодам неисправностей, сообщаемым каждой внутренней частью автомобиля.',
      text7: 'Данные о местонахождении транспортного средства: относится к конкретному географическому местонахождению транспортного средства.',
      text8: '1.1.	Предоставление _ Клиенту с услугами, связанными с автомобилем, через ПРИЛОЖЕНИЕ CFMOTO RIDE .',
      text9:
        '1.1.1.	Потребители могут удаленно управлять транспортными средствами через приложение CFMOTO RIDE (включая просмотр местоположения транспортного средства, настройку информации о транспортном средстве и функций, дистанционное управление состоянием транспортного средства и т. д.).',
      text10: '1.1.2.	Обеспечение планирования маршрута во время навигации, включая расчет расстояния между транспортными средствами и пешую навигацию с целью поиска транспортного средства .',
      text11: '1.2.	Направление необходимых уведомлений Заказчику исходя из состояния автомобиля.',
      text12:
        '1.2.1.	CFMOTO отправляет Клиенту уведомления о техническом обслуживании транспортного средства (например, исходя из общего расстояния, пройденного Клиентом, времени, когда Клиент покупает транспортное средство, требований времени или расстояния для технического обслуживания транспортного средства) .',
      text13:
        '1.2.2.	На основании данных о транспортном средстве CFMOTO будет отправлять Клиенту уведомления о нештатных ситуациях; включая анализ данных OEM (в зависимости от модели) для обеспечения обслуживания клиентов и последующей оптимизации автомобиля .',
      text14: '1.3.	Помощь в анализе причин аварии, если Заказчик сообщает о серьезной аварии ТС.',
      text15:
        '1.3.1.	В случае серьезной аварии Транспортного средства, например, когда Транспортное средство переворачивается или переворачивается на бок во время движения, CFMOTO окажет поддержку Клиенту по запросу в выяснении того, является ли авария следствием дефекта Транспортного средства или других обстоятельств. Запрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
      text16: '1.3.2.	Насколько это позволяют имеющиеся данные, CFMOTO оценит данные относительно причины аварии и предоставит Заказчику соответствующий отчет.',
      text17: '1.4.	Помощь Клиенту в восстановлении ТС после его утери .',
      text18:
        '1.4.1.	Если Транспортное средство потеряно, CFMOTO предоставит Клиенту данные о местонахождении Транспортного средства и другие полезные данные о состоянии Транспортного средства (например, место последней активации, текущий статус транспортного средства и т. д.) по запросу и при наличии.',
      text19: '1.4.2.	Запрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
      text20: '1.5.	Сообщение о проблемах после продажи .',
      text21: '1.5.1.	CFMOTO дистанционно собирает уведомления о кодах ошибок, отправленные ТС в случае неисправности его компонентов, и предоставляет соответствующую информацию по запросу Клиента непосредственно Клиенту.',
      text22: '1.5.2.	Запрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
      text23: '2.	Ограничения и исключения обслуживания',
      text24:
        '2.1.	Прямо указано, что конструктивные или другие технические изменения Транспортного средства могут ограничить предоставление услуг или даже сделать его невозможным, поскольку услуги зависят от правильного предоставления данных о транспортном средстве.',
      text25: '2.2.	Если такие услуги не могут быть предоставлены из-за работы сторонних сетей передачи данных или телекоммуникационных сетей, любая ответственность CFMOTO исключается.',
      text26: '3.	Конфиденциальность',
      text27:
        'CFMOTO будет соблюдать применимые правила защиты данных при обработке персональных данных, связанных с автомобилем CFMOTO . Условия политики конфиденциальности C FMOTO изложены в этом приложении CFMOTO RIDE . Являясь дополнением к политике конфиденциальности , его уведомление соответствует политике конфиденциальности . И Клиент может обратиться к политике конфиденциальности для некоторого контента, связанного с обработкой данных, не охваченного этим уведомлением.',
      text28: '4.	Обслуживание клиентов',
      text29:
        '4.1.	Клиент может свободно отправлять вопросы, комментарии или проблемы, связанные с конфиденциальностью , по адресу CFMOTORIDEAPP@cfmotousa.com или писать по адресу: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Клиент также может позвонить по телефону. Отдел по работе с клиентами CFMOTO по телефону (888) 823-6686. ',
      text30: '5.	Редакции _',
      text31: '5.1.	CFMOTO оставляет за собой право изменять это уведомление в любое время, но мы опубликуем изменения на CFMOTO RIDE. Приложение и/или предоставить уведомление, прежде чем мы сделаем это надлежащим образом.',
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Новые настройки вступят в силу в течение 1-3 минут после включения питания автомобиля. Убедитесь, что автомобиль находится в зоне хорошего сигнала.',
      setSuccess: 'Установлено успешно',
      sure: 'Да',
      confirm: 'Подтвердить',
      cancel: 'Отменить',
      cContent: 'Настройки еще не сохранены, хотите их сохранить?',
      save: 'Сохранить настройки',
      introduce1: 'Рядом с инструкциями по автоматической разблокировке',
      introduce2: 'инструкции по автоматическому отключению питания',
      introduce3: 'Инструкции по автоматическому пробуждению',
      introduce4: 'Задержка выключения света',
      content1: {
        msg1: 'После того, как функция включена, мобильный телефон включает Bluetooth, и приложение продолжает работать. При приближении к автомобилю от дальнего до ближнего расстояния автомобиль может быть автоматически разблокирован и включен.',
        msg2: 'Если он обычно не разблокирован и не включен, нажмите кнопку питания автомобиля, чтобы разблокировать и включить питание.',
        msg3: 'Близость автоматическая разблокировка будет активирована только один раз до отключения bluetooth',
      },
      content2: {
        msg1: 'После того, как функция включена, транспортное средство автоматически отключается через 5 секунд после трех условий выключения транспортного средства, скорость транспортного средства составляет 0 и храм брошен',
        msg2: 'Запуск транспортного средства в течение периода автоматического отключения, скорость транспортного средства не 0, или висок отложен отменит автоматическое отключение',
      },
      content3: {
        msg1: 'После того, как функция включена, когда автомобиль выключен, мобильный телефон включает Bluetooth, и APP продолжает работать или несет физический ключ. При приближении к автомобилю от дальнего до ближнего света огни автомобиля мигают, приветствуя гостей.',
        msg2: 'Чтобы предотвратить потерю мощности транспортного средства частыми триггерами, после того, как приветственная функция будет активирована дважды в течение 30 секунд, она не возобновится до 30 минут позже.',
      },
      content4: {
        msg1: 'После включения функции дальний и ближний свет автоматически включается на 10 секунд после выключения автомобиля.',
      },
    },
    feedback: {
      label: {
        type: 'Тип обратной связи (один выбор)',
        content: 'Описание проблемы',
        fileList: 'Пожалуйста, загрузите фотографию',
        fileList2: '(Максимум 4 фотографии / 1 видео)',
        feedbackCreate: 'Нажмите для обратной связи',
        feedbackSupplement: 'Дополнительная обратная связь',
        backHome: 'Вернуться на главную страницу',
        vehicle: 'связанное транспортное средство',
        selectVehicle: 'выбрать транспортное средство',
      },
      placeholder: {
        'content.bug': 'Пожалуйста, подробно опишите время возникновения, версию APP, модель мобильного телефона, путь работы и описание проблемы, чтобы помочь быстро найти и устранить неисправность!',
        'content.suggest': 'Добро пожаловать, чтобы сделать ценные предложения, мы будем серьезно рассмотреть ваши идеи',
        'content.vehicle': 'Пожалуйста, опишите, когда это произошло, как это произошло и в чем проблема',
        'content.other': 'Пожалуйста, опишите, когда это произошло, как это произошло и в чем проблема',
        'content.supplement': 'Пожалуйста, добавьте описание проблемы',
        vehicle: 'Пожалуйста, выберите автомобиль',
      },
      rules: {
        'type.required': 'Пожалуйста, выберите тип обратной связи',
        'content.required': 'Пожалуйста, введите описание вашей проблемы',
        'fileList.uploading': 'Загрузка, пожалуйста, подождите',
        'fileList.maxSize': 'загружать слишком большой файл',
        'fileList.overType': 'Неподдерживаемый формат',
        'fileList.maxCount': 'Количество загрузок превышает лимит',
        'fileList.acceptImageVideo': 'Видео невозможно выбрать при выборе изображений',
        'vehicle.required': 'Пожалуйста, выберите автомобиль',
      },
      message: {
        empty: 'В настоящее время нет записей обратной связи.',
        finish: 'Ответ',
        loading: 'Загрузка',
        uploadFailed: 'Ошибка загрузки',
        tip: 'Для защиты безопасности вашего аккаунта, пожалуйста, не предоставляйте здесь конфиденциальную личную информацию, такую как пароли от аккаунтов и т.д.',
        feedbackSuccess: 'Отзывы получены',
        'submit.error': 'Сбой обратной связи',
        'submit.success': 'Отзывы получены',
      },
    },
    guide: {
      label: { giveFeedback: 'Не решено, я хочу оставить отзыв' },
    },
    help: {
      label: {
        history: 'Поиск записей',
        cancel: 'Отмена',
        yes: 'Да',
        no: 'Нет',
        unresolved: 'Все еще не можете решить? Нажмите',
        submitFeedback: 'Отправить отзыв',
      },
      placeholder: {
        search: 'Поиск',
        'content.required': 'Введите ключевое слово',
      },
      message: {
        empty: 'Нет связанного контента',
        empty2: 'Предложите изменить ключевые слова или',
        finish: 'Ответ',
        historyDelete: 'Удалить все записи поиска?',
        isHelpful: 'Это помогает?',
      },
    },
    unbinding: {
      label: {
        vin: 'Идент. номер мотоцикл',
        realName: 'Ваше полное имя',
        email: 'Адрес электронной почты',
        phone: 'Номер телефона',
        areaCode: 'Код страны',
        identity: 'Идентификация',
        drivingLicense: 'Свидетельство о регистрации транспортного средства.',
        backHome: 'Вернуться на главную страницу',
        areaCodeTitle: 'Код страны',
        latterTitle: 'Уведомление',
        agree: 'Одобрение',
        disagree: 'Не согласен',
        agreeCheckLabel: 'Я прочитал и согласен',
        agreeCheckTitle: 'Инструкция по подаче заявления на отвязку автомобиля',
      },
      placeholder: {
        vin: 'Пожалуйста, введите VIN',
        realName: 'Пожалуйста, введите ваше настоящее имя',
        email: 'Пожалуйста, введите Ваш адрес электронной почты',
        phone: 'Пожалуйста, введите свой номер телефона',
        identity: 'Главная страница удостоверения личности, водительского удостоверения или паспорта, содержащая личную информацию.',
        drivingLicense: 'Главная страница свидетельства о регистрации транспортного средства с указанием имени владельца и VIN.',
      },
      rules: {
        'agree.required': 'Пожалуйста, прочитайте и согласитесь',
        'vin.required': 'Пожалуйста, введите VIN',
        'vin.pattern': 'Неверный VIN, пожалуйста, проверьте.',
        'realName.required': 'Пожалуйста, введите ваше настоящее имя',
        'email.required': 'Пожалуйста, введите Ваш адрес электронной почты',
        'email.pattern': 'Неверный формат адреса электронной почты, пожалуйста, проверьте.',
        'phone.required': 'Пожалуйста, введите свой номер телефона',
        'phone.pattern': 'Ошибка формата номера телефона, пожалуйста, проверьте',
        'fileList.maxCount': 'Количество загрузок превышает лимит',
        'fileList.uploading': 'Загрузка, пожалуйста, подождите',
      },
      message: {
        imgUploadFailed: 'Не удалось загрузить изображение',
        securityMessage: 'Вышеуказанная информация используется только для проверки личности, CFMOTO обеспечивает защиту вашей информации.',
        resultMessage: 'Мы проверим материалы заявки как можно скорее, пожалуйста, вовремя обратите внимание на панель уведомлений или центр сообщений APP.',
        loading: 'Загрузка',
      },
    },
  },
};
